import { createActionGroup, emptyProps } from '@ngrx/store';

/**
 * NGRX Action Group to manage the Rapider AI Dev Agent lifecycle globally.
 */
export const DevAgentActions = createActionGroup({
  source: 'Dev Agent',
  events: {
    'Trigger Agent': emptyProps(), // Dispatched by the AI Chat Endpoint Card on failure
    'Minimize Agent': emptyProps(),
    'Restore Agent': emptyProps(),
    'Close Agent': emptyProps(),
  },
});
